import {
  JsonToBoolean,
  JsonToDouble,
  JsonToInt32,
  JsonToInt64,
  JsonToString,
  JsonToList,
  ArrayToJson,
  JsonToMap,
  MapToJson,
} from '../Helper/Converter';
import * as dcei_wildsky_common_proto from './dcei_wildsky_common_proto';
class LoginRewardData_RewardData7Days {
  get descriptor() {
    return LoginRewardData_RewardData7Days.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasDay1 = false;
    this._day1 = null;
    this._hasDay2 = false;
    this._day2 = null;
    this._hasDay3 = false;
    this._day3 = null;
    this._hasDay4 = false;
    this._day4 = null;
    this._hasDay5 = false;
    this._day5 = null;
    this._hasDay6 = false;
    this._day6 = null;
    this._hasDay7CardName = false;
    this._day7CardName = null;
    this._hasDuration = false;
    this._duration = null;
    this._hasAllowCatchUp = false;
    this._allowCatchUp = null;
    this._catchUpCosts = [];
  }
  isEmpty() {
    if (this._hasDay1 && !this._day1.isEmpty()) return false;
    if (this._hasDay2 && !this._day2.isEmpty()) return false;
    if (this._hasDay3 && !this._day3.isEmpty()) return false;
    if (this._hasDay4 && !this._day4.isEmpty()) return false;
    if (this._hasDay5 && !this._day5.isEmpty()) return false;
    if (this._hasDay6 && !this._day6.isEmpty()) return false;
    if (this._hasDay7CardName) return false;
    if (this._hasDuration) return false;
    if (this._hasAllowCatchUp) return false;
    if (this._catchUpCosts.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof LoginRewardData_RewardData7Days) {
      return value;
    }
    return LoginRewardData_RewardData7Days.fromJson(value);
  }
  static fromJson(json) {
    const result = new LoginRewardData_RewardData7Days();
    if (json.day1 != null) {
      result._hasDay1 = true;
      result._day1 = dcei_wildsky_common_proto.InventoryItemKeyValuePair.fromJson(json.day1);
    }
    if (json.day2 != null) {
      result._hasDay2 = true;
      result._day2 = dcei_wildsky_common_proto.InventoryItemKeyValuePair.fromJson(json.day2);
    }
    if (json.day3 != null) {
      result._hasDay3 = true;
      result._day3 = dcei_wildsky_common_proto.InventoryItemKeyValuePair.fromJson(json.day3);
    }
    if (json.day4 != null) {
      result._hasDay4 = true;
      result._day4 = dcei_wildsky_common_proto.InventoryItemKeyValuePair.fromJson(json.day4);
    }
    if (json.day5 != null) {
      result._hasDay5 = true;
      result._day5 = dcei_wildsky_common_proto.InventoryItemKeyValuePair.fromJson(json.day5);
    }
    if (json.day6 != null) {
      result._hasDay6 = true;
      result._day6 = dcei_wildsky_common_proto.InventoryItemKeyValuePair.fromJson(json.day6);
    }
    if (json.day7CardName != null) {
      result._hasDay7CardName = true;
      result._day7CardName = JsonToString.fromJson(json.day7CardName);
    }
    if (json.duration != null) {
      result._hasDuration = true;
      result._duration = JsonToInt32.fromJson(json.duration);
    }
    if (json.allowCatchUp != null) {
      result._hasAllowCatchUp = true;
      result._allowCatchUp = JsonToBoolean.fromJson(json.allowCatchUp);
    }
    result._catchUpCosts = JsonToList(json.catchUpCosts, dcei_wildsky_common_proto.InventoryItemKeyValuePair);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasDay1 && !this._day1.isEmpty()) {
      result.day1 = dcei_wildsky_common_proto.InventoryItemKeyValuePair.toJson(this._day1);
    }
    if (this._hasDay2 && !this._day2.isEmpty()) {
      result.day2 = dcei_wildsky_common_proto.InventoryItemKeyValuePair.toJson(this._day2);
    }
    if (this._hasDay3 && !this._day3.isEmpty()) {
      result.day3 = dcei_wildsky_common_proto.InventoryItemKeyValuePair.toJson(this._day3);
    }
    if (this._hasDay4 && !this._day4.isEmpty()) {
      result.day4 = dcei_wildsky_common_proto.InventoryItemKeyValuePair.toJson(this._day4);
    }
    if (this._hasDay5 && !this._day5.isEmpty()) {
      result.day5 = dcei_wildsky_common_proto.InventoryItemKeyValuePair.toJson(this._day5);
    }
    if (this._hasDay6 && !this._day6.isEmpty()) {
      result.day6 = dcei_wildsky_common_proto.InventoryItemKeyValuePair.toJson(this._day6);
    }
    if (this._hasDay7CardName) {
      result.day7CardName = JsonToString.toJson(this._day7CardName);
    }
    if (this._hasDuration) {
      result.duration = JsonToInt32.toJson(this._duration);
    }
    if (this._hasAllowCatchUp) {
      result.allowCatchUp = JsonToBoolean.toJson(this._allowCatchUp);
    }
    if (this._catchUpCosts.length > 0) {
      result.catchUpCosts = ArrayToJson(this._catchUpCosts, dcei_wildsky_common_proto.InventoryItemKeyValuePair);
    }
    return result;
  }
  /**
   * @returns {dcei_wildsky_common_proto.InventoryItemKeyValuePair}
   */
  get day1() {
    return this._hasDay1 ? this._day1 : dcei_wildsky_common_proto.InventoryItemKeyValuePair.default;
  }
  get hasDay1() {
    return this._hasDay1;
  }
  setDay1(path, value) {
    return {type: 'SET', path: path.concat(['day1']), value: value.toJson()};
  }
  deleteDay1(path) {
    return {type: 'DELETE', path: path.concat(['day1'])};
  }
  /**
   * @returns {dcei_wildsky_common_proto.InventoryItemKeyValuePair}
   */
  get day2() {
    return this._hasDay2 ? this._day2 : dcei_wildsky_common_proto.InventoryItemKeyValuePair.default;
  }
  get hasDay2() {
    return this._hasDay2;
  }
  setDay2(path, value) {
    return {type: 'SET', path: path.concat(['day2']), value: value.toJson()};
  }
  deleteDay2(path) {
    return {type: 'DELETE', path: path.concat(['day2'])};
  }
  /**
   * @returns {dcei_wildsky_common_proto.InventoryItemKeyValuePair}
   */
  get day3() {
    return this._hasDay3 ? this._day3 : dcei_wildsky_common_proto.InventoryItemKeyValuePair.default;
  }
  get hasDay3() {
    return this._hasDay3;
  }
  setDay3(path, value) {
    return {type: 'SET', path: path.concat(['day3']), value: value.toJson()};
  }
  deleteDay3(path) {
    return {type: 'DELETE', path: path.concat(['day3'])};
  }
  /**
   * @returns {dcei_wildsky_common_proto.InventoryItemKeyValuePair}
   */
  get day4() {
    return this._hasDay4 ? this._day4 : dcei_wildsky_common_proto.InventoryItemKeyValuePair.default;
  }
  get hasDay4() {
    return this._hasDay4;
  }
  setDay4(path, value) {
    return {type: 'SET', path: path.concat(['day4']), value: value.toJson()};
  }
  deleteDay4(path) {
    return {type: 'DELETE', path: path.concat(['day4'])};
  }
  /**
   * @returns {dcei_wildsky_common_proto.InventoryItemKeyValuePair}
   */
  get day5() {
    return this._hasDay5 ? this._day5 : dcei_wildsky_common_proto.InventoryItemKeyValuePair.default;
  }
  get hasDay5() {
    return this._hasDay5;
  }
  setDay5(path, value) {
    return {type: 'SET', path: path.concat(['day5']), value: value.toJson()};
  }
  deleteDay5(path) {
    return {type: 'DELETE', path: path.concat(['day5'])};
  }
  /**
   * @returns {dcei_wildsky_common_proto.InventoryItemKeyValuePair}
   */
  get day6() {
    return this._hasDay6 ? this._day6 : dcei_wildsky_common_proto.InventoryItemKeyValuePair.default;
  }
  get hasDay6() {
    return this._hasDay6;
  }
  setDay6(path, value) {
    return {type: 'SET', path: path.concat(['day6']), value: value.toJson()};
  }
  deleteDay6(path) {
    return {type: 'DELETE', path: path.concat(['day6'])};
  }
  /**
   * @returns {string}
   */
  get day7CardName() {
    return this._hasDay7CardName ? this._day7CardName : JsonToString.default;
  }
  get hasDay7CardName() {
    return this._hasDay7CardName;
  }
  setDay7CardName(path, value) {
    return {type: 'SET', path: path.concat(['day7CardName']), value};
  }
  deleteDay7CardName(path) {
    return {type: 'DELETE', path: path.concat(['day7CardName'])};
  }
  /**
   * @returns {number}
   */
  get duration() {
    return this._hasDuration ? this._duration : JsonToInt32.default;
  }
  get hasDuration() {
    return this._hasDuration;
  }
  setDuration(path, value) {
    return {type: 'SET', path: path.concat(['duration']), value};
  }
  deleteDuration(path) {
    return {type: 'DELETE', path: path.concat(['duration'])};
  }
  /**
   * @returns {boolean}
   */
  get allowCatchUp() {
    return this._hasAllowCatchUp ? this._allowCatchUp : JsonToBoolean.default;
  }
  get hasAllowCatchUp() {
    return this._hasAllowCatchUp;
  }
  setAllowCatchUp(path, value) {
    return {type: 'SET', path: path.concat(['allowCatchUp']), value};
  }
  deleteAllowCatchUp(path) {
    return {type: 'DELETE', path: path.concat(['allowCatchUp'])};
  }
  /**
   * @returns {dcei_wildsky_common_proto.InventoryItemKeyValuePair[]}
   */
  get catchUpCosts() {
    return this._catchUpCosts;
  }
  addCatchUpCosts(path, value) {
    return {type: 'ADD', path: path.concat(['catchUpCosts']), value: value.toJson()};
  }
  setCatchUpCosts(path, value) {
    return {type: 'SET', path: path.concat(['catchUpCosts']), value: ArrayToJson(value, dcei_wildsky_common_proto.InventoryItemKeyValuePair)};
  }
  setCatchUpCostsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['catchUpCosts', key]), value: value.toJson()};
  }
  deleteCatchUpCosts(path) {
    return {type: 'DELETE', path: path.concat(['catchUpCosts'])};
  }
  deleteCatchUpCostsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['catchUpCosts', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "day1": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new LoginRewardData_RewardData7Days(this);
              copy._hasDay1 = true;
              copy._day1 = dcei_wildsky_common_proto.InventoryItemKeyValuePair.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDay1) {
                return this;
              }
              const copy = new LoginRewardData_RewardData7Days(this);
              copy._hasDay1 = false;
              copy._day1 = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasDay1) {
            const copy = new LoginRewardData_RewardData7Days(this);
            copy._hasDay1 = true;
            copy._day1 = dcei_wildsky_common_proto.InventoryItemKeyValuePair.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._day1.apply(type, path.slice(1), value);
          if (newValue === this._day1) {
            return this;
          }
          const copy = new LoginRewardData_RewardData7Days(this);
          copy._day1 = copy._day1.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "day2": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new LoginRewardData_RewardData7Days(this);
              copy._hasDay2 = true;
              copy._day2 = dcei_wildsky_common_proto.InventoryItemKeyValuePair.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDay2) {
                return this;
              }
              const copy = new LoginRewardData_RewardData7Days(this);
              copy._hasDay2 = false;
              copy._day2 = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasDay2) {
            const copy = new LoginRewardData_RewardData7Days(this);
            copy._hasDay2 = true;
            copy._day2 = dcei_wildsky_common_proto.InventoryItemKeyValuePair.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._day2.apply(type, path.slice(1), value);
          if (newValue === this._day2) {
            return this;
          }
          const copy = new LoginRewardData_RewardData7Days(this);
          copy._day2 = copy._day2.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "day3": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new LoginRewardData_RewardData7Days(this);
              copy._hasDay3 = true;
              copy._day3 = dcei_wildsky_common_proto.InventoryItemKeyValuePair.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDay3) {
                return this;
              }
              const copy = new LoginRewardData_RewardData7Days(this);
              copy._hasDay3 = false;
              copy._day3 = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasDay3) {
            const copy = new LoginRewardData_RewardData7Days(this);
            copy._hasDay3 = true;
            copy._day3 = dcei_wildsky_common_proto.InventoryItemKeyValuePair.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._day3.apply(type, path.slice(1), value);
          if (newValue === this._day3) {
            return this;
          }
          const copy = new LoginRewardData_RewardData7Days(this);
          copy._day3 = copy._day3.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "day4": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new LoginRewardData_RewardData7Days(this);
              copy._hasDay4 = true;
              copy._day4 = dcei_wildsky_common_proto.InventoryItemKeyValuePair.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDay4) {
                return this;
              }
              const copy = new LoginRewardData_RewardData7Days(this);
              copy._hasDay4 = false;
              copy._day4 = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasDay4) {
            const copy = new LoginRewardData_RewardData7Days(this);
            copy._hasDay4 = true;
            copy._day4 = dcei_wildsky_common_proto.InventoryItemKeyValuePair.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._day4.apply(type, path.slice(1), value);
          if (newValue === this._day4) {
            return this;
          }
          const copy = new LoginRewardData_RewardData7Days(this);
          copy._day4 = copy._day4.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "day5": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new LoginRewardData_RewardData7Days(this);
              copy._hasDay5 = true;
              copy._day5 = dcei_wildsky_common_proto.InventoryItemKeyValuePair.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDay5) {
                return this;
              }
              const copy = new LoginRewardData_RewardData7Days(this);
              copy._hasDay5 = false;
              copy._day5 = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasDay5) {
            const copy = new LoginRewardData_RewardData7Days(this);
            copy._hasDay5 = true;
            copy._day5 = dcei_wildsky_common_proto.InventoryItemKeyValuePair.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._day5.apply(type, path.slice(1), value);
          if (newValue === this._day5) {
            return this;
          }
          const copy = new LoginRewardData_RewardData7Days(this);
          copy._day5 = copy._day5.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "day6": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new LoginRewardData_RewardData7Days(this);
              copy._hasDay6 = true;
              copy._day6 = dcei_wildsky_common_proto.InventoryItemKeyValuePair.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDay6) {
                return this;
              }
              const copy = new LoginRewardData_RewardData7Days(this);
              copy._hasDay6 = false;
              copy._day6 = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasDay6) {
            const copy = new LoginRewardData_RewardData7Days(this);
            copy._hasDay6 = true;
            copy._day6 = dcei_wildsky_common_proto.InventoryItemKeyValuePair.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._day6.apply(type, path.slice(1), value);
          if (newValue === this._day6) {
            return this;
          }
          const copy = new LoginRewardData_RewardData7Days(this);
          copy._day6 = copy._day6.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "day7CardName": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new LoginRewardData_RewardData7Days(this);
              copy._hasDay7CardName = true;
              copy._day7CardName = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDay7CardName) {
                return this;
              }
              const copy = new LoginRewardData_RewardData7Days(this);
              copy._hasDay7CardName = false;
              copy._day7CardName = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "duration": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new LoginRewardData_RewardData7Days(this);
              copy._hasDuration = true;
              copy._duration = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDuration) {
                return this;
              }
              const copy = new LoginRewardData_RewardData7Days(this);
              copy._hasDuration = false;
              copy._duration = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "allowCatchUp": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new LoginRewardData_RewardData7Days(this);
              copy._hasAllowCatchUp = true;
              copy._allowCatchUp = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAllowCatchUp) {
                return this;
              }
              const copy = new LoginRewardData_RewardData7Days(this);
              copy._hasAllowCatchUp = false;
              copy._allowCatchUp = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "catchUpCosts": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new LoginRewardData_RewardData7Days(this);
              copy._catchUpCosts = [];        for (let i of value) {
                copy._catchUpCosts.push(dcei_wildsky_common_proto.InventoryItemKeyValuePair.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new LoginRewardData_RewardData7Days(this);
              copy._catchUpCosts = copy._catchUpCosts.concat([dcei_wildsky_common_proto.InventoryItemKeyValuePair.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._catchUpCosts.length === 0) {
                return this;
              }
              const copy = new LoginRewardData_RewardData7Days(this);
              copy._catchUpCosts = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._catchUpCosts.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new LoginRewardData_RewardData7Days(this);
              copy._catchUpCosts = copy._catchUpCosts.slice();
              copy._catchUpCosts[path[1]] = dcei_wildsky_common_proto.InventoryItemKeyValuePair.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new LoginRewardData_RewardData7Days(this);
              copy._catchUpCosts = copy._catchUpCosts.slice(0, path[1]).concat(copy._catchUpCosts.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._catchUpCosts.length) {
            return this;
          }
          const oldValue = this._catchUpCosts[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new LoginRewardData_RewardData7Days(this);
          copy._catchUpCosts = copy._catchUpCosts.slice();
          copy._catchUpCosts[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {LoginRewardData_RewardData7Days} other
   * @returns {LoginRewardData_RewardData7Days}
   */
  merge(other) {
    const copy = new LoginRewardData_RewardData7Days(this);
    if (other._hasDay1) {
      if (copy._hasDay1) {
        copy._day1 = copy.day1.merge(other.day1);
      } else {
        copy._day1 = other._day1;
      }
      copy._hasDay1 = true;
    }
    if (other._hasDay2) {
      if (copy._hasDay2) {
        copy._day2 = copy.day2.merge(other.day2);
      } else {
        copy._day2 = other._day2;
      }
      copy._hasDay2 = true;
    }
    if (other._hasDay3) {
      if (copy._hasDay3) {
        copy._day3 = copy.day3.merge(other.day3);
      } else {
        copy._day3 = other._day3;
      }
      copy._hasDay3 = true;
    }
    if (other._hasDay4) {
      if (copy._hasDay4) {
        copy._day4 = copy.day4.merge(other.day4);
      } else {
        copy._day4 = other._day4;
      }
      copy._hasDay4 = true;
    }
    if (other._hasDay5) {
      if (copy._hasDay5) {
        copy._day5 = copy.day5.merge(other.day5);
      } else {
        copy._day5 = other._day5;
      }
      copy._hasDay5 = true;
    }
    if (other._hasDay6) {
      if (copy._hasDay6) {
        copy._day6 = copy.day6.merge(other.day6);
      } else {
        copy._day6 = other._day6;
      }
      copy._hasDay6 = true;
    }
    if (other._hasDay7CardName) {
      copy._hasDay7CardName = true;
      copy._day7CardName = other._day7CardName;
    }
    if (other._hasDuration) {
      copy._hasDuration = true;
      copy._duration = other._duration;
    }
    if (other._hasAllowCatchUp) {
      copy._hasAllowCatchUp = true;
      copy._allowCatchUp = other._allowCatchUp;
    }
    copy._catchUpCosts = this._catchUpCosts.concat(other._catchUpCosts);
    return copy;
  }
}
LoginRewardData_RewardData7Days.default = new LoginRewardData_RewardData7Days();
class LoginRewardData_RewardData7Days_Builder {
  constructor(value) {
    this._value = new LoginRewardData_RewardData7Days(value);
  }
  build() {
    return new LoginRewardData_RewardData7Days(this._value);
  }
  setDay1(value) {
    this._value._hasDay1 = true;
    this._value._day1 = value;
    return this;
  }
  deleteDay1() {
    this._value._hasDay1 = false;
    this._value._day1 = null;
    return this;
  }
  setDay2(value) {
    this._value._hasDay2 = true;
    this._value._day2 = value;
    return this;
  }
  deleteDay2() {
    this._value._hasDay2 = false;
    this._value._day2 = null;
    return this;
  }
  setDay3(value) {
    this._value._hasDay3 = true;
    this._value._day3 = value;
    return this;
  }
  deleteDay3() {
    this._value._hasDay3 = false;
    this._value._day3 = null;
    return this;
  }
  setDay4(value) {
    this._value._hasDay4 = true;
    this._value._day4 = value;
    return this;
  }
  deleteDay4() {
    this._value._hasDay4 = false;
    this._value._day4 = null;
    return this;
  }
  setDay5(value) {
    this._value._hasDay5 = true;
    this._value._day5 = value;
    return this;
  }
  deleteDay5() {
    this._value._hasDay5 = false;
    this._value._day5 = null;
    return this;
  }
  setDay6(value) {
    this._value._hasDay6 = true;
    this._value._day6 = value;
    return this;
  }
  deleteDay6() {
    this._value._hasDay6 = false;
    this._value._day6 = null;
    return this;
  }
  setDay7CardName(value) {
    this._value._hasDay7CardName = true;
    this._value._day7CardName = value;
    return this;
  }
  deleteDay7CardName() {
    this._value._hasDay7CardName = false;
    this._value._day7CardName = null;
    return this;
  }
  setDuration(value) {
    this._value._hasDuration = true;
    this._value._duration = value;
    return this;
  }
  deleteDuration() {
    this._value._hasDuration = false;
    this._value._duration = null;
    return this;
  }
  setAllowCatchUp(value) {
    this._value._hasAllowCatchUp = true;
    this._value._allowCatchUp = value;
    return this;
  }
  deleteAllowCatchUp() {
    this._value._hasAllowCatchUp = false;
    this._value._allowCatchUp = null;
    return this;
  }
  addAllCatchUpCosts(values) {
    this._value._catchUpCosts = this._value._catchUpCosts.concat(values);
    return this;
  }
  addCatchUpCosts(value) {
    this._value._catchUpCosts = this._value._catchUpCosts.concat([value]);
    return this;
  }
  setCatchUpCosts(index, value) {
    this._value._catchUpCosts = this._value._catchUpCosts.concat();
    this._value._catchUpCosts[index] = value;
    return this;
  }
  clearCatchUpCosts() {
    this._value._catchUpCosts = [];
    return this;
  }
}
LoginRewardData_RewardData7Days.Builder = LoginRewardData_RewardData7Days_Builder;
class LoginRewardData_RewardData7Days_WithParent {
  /**
   * @param {LoginRewardData_RewardData7Days} value
   * @param {LoginRewardData_RewardData7Days_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return LoginRewardData_RewardData7Days.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasDay1() {
    if (this._cachedHasDay1 === undefined) {
      if (this._value.hasDay1) {
        this._cachedHasDay1 = true;
      } else {
        this._cachedHasDay1 = this._parent ? this._parent.hasDay1 : false;
      }
    }
    return this._cachedHasDay1;
  }
  get day1() {
    if (!this._cachedDay1) {
      if (this._value.hasDay1) {
        this._cachedDay1 = new dcei_wildsky_common_proto.InventoryItemKeyValuePair.WithParent(this._value.day1, this._parent && this._parent.hasDay1 ? this._parent.day1 : null);
      } else {
        this._cachedDay1 = this._parent ? new dcei_wildsky_common_proto.InventoryItemKeyValuePair.WithParent(dcei_wildsky_common_proto.InventoryItemKeyValuePair.default, this._parent.day1) : dcei_wildsky_common_proto.InventoryItemKeyValuePair.WithParent.default;
      }
    }
    return this._cachedDay1;
  }
  get hasDay2() {
    if (this._cachedHasDay2 === undefined) {
      if (this._value.hasDay2) {
        this._cachedHasDay2 = true;
      } else {
        this._cachedHasDay2 = this._parent ? this._parent.hasDay2 : false;
      }
    }
    return this._cachedHasDay2;
  }
  get day2() {
    if (!this._cachedDay2) {
      if (this._value.hasDay2) {
        this._cachedDay2 = new dcei_wildsky_common_proto.InventoryItemKeyValuePair.WithParent(this._value.day2, this._parent && this._parent.hasDay2 ? this._parent.day2 : null);
      } else {
        this._cachedDay2 = this._parent ? new dcei_wildsky_common_proto.InventoryItemKeyValuePair.WithParent(dcei_wildsky_common_proto.InventoryItemKeyValuePair.default, this._parent.day2) : dcei_wildsky_common_proto.InventoryItemKeyValuePair.WithParent.default;
      }
    }
    return this._cachedDay2;
  }
  get hasDay3() {
    if (this._cachedHasDay3 === undefined) {
      if (this._value.hasDay3) {
        this._cachedHasDay3 = true;
      } else {
        this._cachedHasDay3 = this._parent ? this._parent.hasDay3 : false;
      }
    }
    return this._cachedHasDay3;
  }
  get day3() {
    if (!this._cachedDay3) {
      if (this._value.hasDay3) {
        this._cachedDay3 = new dcei_wildsky_common_proto.InventoryItemKeyValuePair.WithParent(this._value.day3, this._parent && this._parent.hasDay3 ? this._parent.day3 : null);
      } else {
        this._cachedDay3 = this._parent ? new dcei_wildsky_common_proto.InventoryItemKeyValuePair.WithParent(dcei_wildsky_common_proto.InventoryItemKeyValuePair.default, this._parent.day3) : dcei_wildsky_common_proto.InventoryItemKeyValuePair.WithParent.default;
      }
    }
    return this._cachedDay3;
  }
  get hasDay4() {
    if (this._cachedHasDay4 === undefined) {
      if (this._value.hasDay4) {
        this._cachedHasDay4 = true;
      } else {
        this._cachedHasDay4 = this._parent ? this._parent.hasDay4 : false;
      }
    }
    return this._cachedHasDay4;
  }
  get day4() {
    if (!this._cachedDay4) {
      if (this._value.hasDay4) {
        this._cachedDay4 = new dcei_wildsky_common_proto.InventoryItemKeyValuePair.WithParent(this._value.day4, this._parent && this._parent.hasDay4 ? this._parent.day4 : null);
      } else {
        this._cachedDay4 = this._parent ? new dcei_wildsky_common_proto.InventoryItemKeyValuePair.WithParent(dcei_wildsky_common_proto.InventoryItemKeyValuePair.default, this._parent.day4) : dcei_wildsky_common_proto.InventoryItemKeyValuePair.WithParent.default;
      }
    }
    return this._cachedDay4;
  }
  get hasDay5() {
    if (this._cachedHasDay5 === undefined) {
      if (this._value.hasDay5) {
        this._cachedHasDay5 = true;
      } else {
        this._cachedHasDay5 = this._parent ? this._parent.hasDay5 : false;
      }
    }
    return this._cachedHasDay5;
  }
  get day5() {
    if (!this._cachedDay5) {
      if (this._value.hasDay5) {
        this._cachedDay5 = new dcei_wildsky_common_proto.InventoryItemKeyValuePair.WithParent(this._value.day5, this._parent && this._parent.hasDay5 ? this._parent.day5 : null);
      } else {
        this._cachedDay5 = this._parent ? new dcei_wildsky_common_proto.InventoryItemKeyValuePair.WithParent(dcei_wildsky_common_proto.InventoryItemKeyValuePair.default, this._parent.day5) : dcei_wildsky_common_proto.InventoryItemKeyValuePair.WithParent.default;
      }
    }
    return this._cachedDay5;
  }
  get hasDay6() {
    if (this._cachedHasDay6 === undefined) {
      if (this._value.hasDay6) {
        this._cachedHasDay6 = true;
      } else {
        this._cachedHasDay6 = this._parent ? this._parent.hasDay6 : false;
      }
    }
    return this._cachedHasDay6;
  }
  get day6() {
    if (!this._cachedDay6) {
      if (this._value.hasDay6) {
        this._cachedDay6 = new dcei_wildsky_common_proto.InventoryItemKeyValuePair.WithParent(this._value.day6, this._parent && this._parent.hasDay6 ? this._parent.day6 : null);
      } else {
        this._cachedDay6 = this._parent ? new dcei_wildsky_common_proto.InventoryItemKeyValuePair.WithParent(dcei_wildsky_common_proto.InventoryItemKeyValuePair.default, this._parent.day6) : dcei_wildsky_common_proto.InventoryItemKeyValuePair.WithParent.default;
      }
    }
    return this._cachedDay6;
  }
  get hasDay7CardName() {
    if (this._cachedHasDay7CardName === undefined) {
      if (this._value.hasDay7CardName) {
        this._cachedHasDay7CardName = true;
      } else {
        this._cachedHasDay7CardName = this._parent ? this._parent.hasDay7CardName : false;
      }
    }
    return this._cachedHasDay7CardName;
  }
  get day7CardName() {
    if (this._cachedDay7CardName === undefined) {
      if (this._value.hasDay7CardName) {
        this._cachedDay7CardName = this._value.day7CardName;
      } else {
        this._cachedDay7CardName = this._parent ? this._parent.day7CardName : this._value.day7CardName;
      }
    }
    return this._cachedDay7CardName;
  }
  get hasDuration() {
    if (this._cachedHasDuration === undefined) {
      if (this._value.hasDuration) {
        this._cachedHasDuration = true;
      } else {
        this._cachedHasDuration = this._parent ? this._parent.hasDuration : false;
      }
    }
    return this._cachedHasDuration;
  }
  get duration() {
    if (this._cachedDuration === undefined) {
      if (this._value.hasDuration) {
        this._cachedDuration = this._value.duration;
      } else {
        this._cachedDuration = this._parent ? this._parent.duration : this._value.duration;
      }
    }
    return this._cachedDuration;
  }
  get hasAllowCatchUp() {
    if (this._cachedHasAllowCatchUp === undefined) {
      if (this._value.hasAllowCatchUp) {
        this._cachedHasAllowCatchUp = true;
      } else {
        this._cachedHasAllowCatchUp = this._parent ? this._parent.hasAllowCatchUp : false;
      }
    }
    return this._cachedHasAllowCatchUp;
  }
  get allowCatchUp() {
    if (this._cachedAllowCatchUp === undefined) {
      if (this._value.hasAllowCatchUp) {
        this._cachedAllowCatchUp = this._value.allowCatchUp;
      } else {
        this._cachedAllowCatchUp = this._parent ? this._parent.allowCatchUp : this._value.allowCatchUp;
      }
    }
    return this._cachedAllowCatchUp;
  }
  get selfCatchUpCosts() {
    if (!this._selfCatchUpCosts) {
      this._selfCatchUpCosts = [];
      for (let i of this._value.catchUpCosts) {
        this._selfCatchUpCosts.push(new dcei_wildsky_common_proto.InventoryItemKeyValuePair.WithParent(i, null));
      }
    }
    return this._selfCatchUpCosts;
  }
  get inherentCatchUpCosts() {
    if (!this._inherentCatchUpCosts) {
      this._inherentCatchUpCosts = this._parent ? this._parent.catchUpCosts : [];
    }
    return this._inherentCatchUpCosts;
  }
  get catchUpCosts() {
    if (!this._allCatchUpCosts) {
      this._allCatchUpCosts = this._parent ? this._parent.catchUpCosts.concat(this.selfCatchUpCosts) : this.selfCatchUpCosts;
    }
    return this._allCatchUpCosts;
  }
  update(current, parent) {
    const result = new LoginRewardData_RewardData7Days_WithParent(current, parent);
    if (this._cachedDay1 && this._value.hasDay1 && current.hasDay1) {
      if (this._value.day1 === current.day1 && this._parent === parent) {
        result._cachedDay1 = this._cachedDay1;
      } else {
        result._cachedDay1 = this._cachedDay1.update(current.day1, parent && parent.hasDay1 ? parent.day1 : null);
      }
    }
    if (this._cachedDay2 && this._value.hasDay2 && current.hasDay2) {
      if (this._value.day2 === current.day2 && this._parent === parent) {
        result._cachedDay2 = this._cachedDay2;
      } else {
        result._cachedDay2 = this._cachedDay2.update(current.day2, parent && parent.hasDay2 ? parent.day2 : null);
      }
    }
    if (this._cachedDay3 && this._value.hasDay3 && current.hasDay3) {
      if (this._value.day3 === current.day3 && this._parent === parent) {
        result._cachedDay3 = this._cachedDay3;
      } else {
        result._cachedDay3 = this._cachedDay3.update(current.day3, parent && parent.hasDay3 ? parent.day3 : null);
      }
    }
    if (this._cachedDay4 && this._value.hasDay4 && current.hasDay4) {
      if (this._value.day4 === current.day4 && this._parent === parent) {
        result._cachedDay4 = this._cachedDay4;
      } else {
        result._cachedDay4 = this._cachedDay4.update(current.day4, parent && parent.hasDay4 ? parent.day4 : null);
      }
    }
    if (this._cachedDay5 && this._value.hasDay5 && current.hasDay5) {
      if (this._value.day5 === current.day5 && this._parent === parent) {
        result._cachedDay5 = this._cachedDay5;
      } else {
        result._cachedDay5 = this._cachedDay5.update(current.day5, parent && parent.hasDay5 ? parent.day5 : null);
      }
    }
    if (this._cachedDay6 && this._value.hasDay6 && current.hasDay6) {
      if (this._value.day6 === current.day6 && this._parent === parent) {
        result._cachedDay6 = this._cachedDay6;
      } else {
        result._cachedDay6 = this._cachedDay6.update(current.day6, parent && parent.hasDay6 ? parent.day6 : null);
      }
    }
    if (this._selfCatchUpCosts) {
      if (this._value.catchUpCosts === current.catchUpCosts) {
        result._selfCatchUpCosts = this._selfCatchUpCosts;
      } else {
        result._selfCatchUpCosts = [];
        for (let i = 0; i < current.catchUpCosts.length; i++) {
          const oldValue = this._value.catchUpCosts[i];
          if (oldValue) {
            const oldCache = this._selfCatchUpCosts[i];
            if (oldValue === current.catchUpCosts[i]) {
              result._selfCatchUpCosts[i] = oldCache;
            } else {
              result._selfCatchUpCosts[i] = oldCache.update(current.catchUpCosts[i], null);
            }
          } else {
            result._selfCatchUpCosts[i] = new dcei_wildsky_common_proto.InventoryItemKeyValuePair.WithParent(current.catchUpCosts[i], null);
          }
        }
      }
    }
    return result;
  }
}
LoginRewardData_RewardData7Days_WithParent.default = new LoginRewardData_RewardData7Days_WithParent(LoginRewardData_RewardData7Days.default, null);
LoginRewardData_RewardData7Days.WithParent = LoginRewardData_RewardData7Days_WithParent;
class LoginRewardData_RewardData7Days_Descriptor {
  get day1() {
    if (!this._day1) {
      this._day1 = {
        name: "day1",
        Name: "Day1",
        number: 1,
        protoType: 11,
        protoName: "day_1",
        type: dcei_wildsky_common_proto.InventoryItemKeyValuePair,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._day1;
  }
  get day2() {
    if (!this._day2) {
      this._day2 = {
        name: "day2",
        Name: "Day2",
        number: 2,
        protoType: 11,
        protoName: "day_2",
        type: dcei_wildsky_common_proto.InventoryItemKeyValuePair,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._day2;
  }
  get day3() {
    if (!this._day3) {
      this._day3 = {
        name: "day3",
        Name: "Day3",
        number: 3,
        protoType: 11,
        protoName: "day_3",
        type: dcei_wildsky_common_proto.InventoryItemKeyValuePair,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._day3;
  }
  get day4() {
    if (!this._day4) {
      this._day4 = {
        name: "day4",
        Name: "Day4",
        number: 4,
        protoType: 11,
        protoName: "day_4",
        type: dcei_wildsky_common_proto.InventoryItemKeyValuePair,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._day4;
  }
  get day5() {
    if (!this._day5) {
      this._day5 = {
        name: "day5",
        Name: "Day5",
        number: 5,
        protoType: 11,
        protoName: "day_5",
        type: dcei_wildsky_common_proto.InventoryItemKeyValuePair,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._day5;
  }
  get day6() {
    if (!this._day6) {
      this._day6 = {
        name: "day6",
        Name: "Day6",
        number: 6,
        protoType: 11,
        protoName: "day_6",
        type: dcei_wildsky_common_proto.InventoryItemKeyValuePair,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._day6;
  }
  get day7CardName() {
    if (!this._day7CardName) {
      this._day7CardName = {
        name: "day7CardName",
        Name: "Day7CardName",
        number: 7,
        protoType: 9,
        protoName: "day_7_card_name",
        type: JsonToString,
        options: {
          valueDropdown: "CardNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._day7CardName;
  }
  get duration() {
    if (!this._duration) {
      this._duration = {
        name: "duration",
        Name: "Duration",
        number: 8,
        protoType: 5,
        protoName: "duration",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._duration;
  }
  get allowCatchUp() {
    if (!this._allowCatchUp) {
      this._allowCatchUp = {
        name: "allowCatchUp",
        Name: "AllowCatchUp",
        number: 11,
        protoType: 8,
        protoName: "allow_catch_up",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._allowCatchUp;
  }
  get catchUpCosts() {
    if (!this._catchUpCosts) {
      this._catchUpCosts = {
        name: "catchUpCosts",
        Name: "CatchUpCosts",
        number: 12,
        protoType: 11,
        protoName: "catch_up_costs",
        type: dcei_wildsky_common_proto.InventoryItemKeyValuePair,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._catchUpCosts;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.day1,
        this.day2,
        this.day3,
        this.day4,
        this.day5,
        this.day6,
        this.day7CardName,
        this.duration,
        this.allowCatchUp,
        this.catchUpCosts,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForDay1",
        Name: "DummyOneofForDay1",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDay2",
        Name: "DummyOneofForDay2",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDay3",
        Name: "DummyOneofForDay3",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDay4",
        Name: "DummyOneofForDay4",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDay5",
        Name: "DummyOneofForDay5",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDay6",
        Name: "DummyOneofForDay6",
        fields: [
          this.fields[5],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDay7CardName",
        Name: "DummyOneofForDay7CardName",
        fields: [
          this.fields[6],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDuration",
        Name: "DummyOneofForDuration",
        fields: [
          this.fields[7],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForAllowCatchUp",
        Name: "DummyOneofForAllowCatchUp",
        fields: [
          this.fields[8],
        ],
      });
    }
    return this._oneofs;
  }
}
LoginRewardData_RewardData7Days.descriptor = new LoginRewardData_RewardData7Days_Descriptor();
export class LoginRewardData {
  get descriptor() {
    return LoginRewardData.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._rewardItems = [];
    this._hasDailyResetTime = false;
    this._dailyResetTime = null;
    this._adsDays = [];
    this._hasRewards7Days = false;
    this._rewards7Days = null;
  }
  isEmpty() {
    if (this._rewardItems.length > 0) return false;
    if (this._hasDailyResetTime) return false;
    if (this._adsDays.length > 0) return false;
    if (this._hasRewards7Days && !this._rewards7Days.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof LoginRewardData) {
      return value;
    }
    return LoginRewardData.fromJson(value);
  }
  static fromJson(json) {
    const result = new LoginRewardData();
    result._rewardItems = JsonToList(json.rewardItems, dcei_wildsky_common_proto.InventoryItemKeyValuePair);
    if (json.dailyResetTime != null) {
      result._hasDailyResetTime = true;
      result._dailyResetTime = JsonToInt32.fromJson(json.dailyResetTime);
    }
    result._adsDays = JsonToList(json.adsDays, JsonToInt32);
    if (json.rewards7Days != null) {
      result._hasRewards7Days = true;
      result._rewards7Days = LoginRewardData_RewardData7Days.fromJson(json.rewards7Days);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._rewardItems.length > 0) {
      result.rewardItems = ArrayToJson(this._rewardItems, dcei_wildsky_common_proto.InventoryItemKeyValuePair);
    }
    if (this._hasDailyResetTime) {
      result.dailyResetTime = JsonToInt32.toJson(this._dailyResetTime);
    }
    if (this._adsDays.length > 0) {
      result.adsDays = ArrayToJson(this._adsDays, JsonToInt32);
    }
    if (this._hasRewards7Days && !this._rewards7Days.isEmpty()) {
      result.rewards7Days = LoginRewardData_RewardData7Days.toJson(this._rewards7Days);
    }
    return result;
  }
  /**
   * @returns {dcei_wildsky_common_proto.InventoryItemKeyValuePair[]}
   */
  get rewardItems() {
    return this._rewardItems;
  }
  addRewardItems(path, value) {
    return {type: 'ADD', path: path.concat(['rewardItems']), value: value.toJson()};
  }
  setRewardItems(path, value) {
    return {type: 'SET', path: path.concat(['rewardItems']), value: ArrayToJson(value, dcei_wildsky_common_proto.InventoryItemKeyValuePair)};
  }
  setRewardItemsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['rewardItems', key]), value: value.toJson()};
  }
  deleteRewardItems(path) {
    return {type: 'DELETE', path: path.concat(['rewardItems'])};
  }
  deleteRewardItemsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['rewardItems', key])};
  }
  /**
   * @returns {number}
   */
  get dailyResetTime() {
    return this._hasDailyResetTime ? this._dailyResetTime : JsonToInt32.default;
  }
  get hasDailyResetTime() {
    return this._hasDailyResetTime;
  }
  setDailyResetTime(path, value) {
    return {type: 'SET', path: path.concat(['dailyResetTime']), value};
  }
  deleteDailyResetTime(path) {
    return {type: 'DELETE', path: path.concat(['dailyResetTime'])};
  }
  /**
   * @returns {number[]}
   */
  get adsDays() {
    return this._adsDays;
  }
  addAdsDays(path, value) {
    return {type: 'ADD', path: path.concat(['adsDays']), value};
  }
  setAdsDays(path, value) {
    return {type: 'SET', path: path.concat(['adsDays']), value: ArrayToJson(value, JsonToInt32)};
  }
  setAdsDaysByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['adsDays', key]), value};
  }
  deleteAdsDays(path) {
    return {type: 'DELETE', path: path.concat(['adsDays'])};
  }
  deleteAdsDaysByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['adsDays', key])};
  }
  /**
   * @returns {LoginRewardData_RewardData7Days}
   */
  get rewards7Days() {
    return this._hasRewards7Days ? this._rewards7Days : LoginRewardData_RewardData7Days.default;
  }
  get hasRewards7Days() {
    return this._hasRewards7Days;
  }
  setRewards7Days(path, value) {
    return {type: 'SET', path: path.concat(['rewards7Days']), value: value.toJson()};
  }
  deleteRewards7Days(path) {
    return {type: 'DELETE', path: path.concat(['rewards7Days'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "rewardItems": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new LoginRewardData(this);
              copy._rewardItems = [];        for (let i of value) {
                copy._rewardItems.push(dcei_wildsky_common_proto.InventoryItemKeyValuePair.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new LoginRewardData(this);
              copy._rewardItems = copy._rewardItems.concat([dcei_wildsky_common_proto.InventoryItemKeyValuePair.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._rewardItems.length === 0) {
                return this;
              }
              const copy = new LoginRewardData(this);
              copy._rewardItems = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._rewardItems.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new LoginRewardData(this);
              copy._rewardItems = copy._rewardItems.slice();
              copy._rewardItems[path[1]] = dcei_wildsky_common_proto.InventoryItemKeyValuePair.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new LoginRewardData(this);
              copy._rewardItems = copy._rewardItems.slice(0, path[1]).concat(copy._rewardItems.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._rewardItems.length) {
            return this;
          }
          const oldValue = this._rewardItems[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new LoginRewardData(this);
          copy._rewardItems = copy._rewardItems.slice();
          copy._rewardItems[key] = newValue;
          return copy;
        }
      }
      case "dailyResetTime": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new LoginRewardData(this);
              copy._hasDailyResetTime = true;
              copy._dailyResetTime = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDailyResetTime) {
                return this;
              }
              const copy = new LoginRewardData(this);
              copy._hasDailyResetTime = false;
              copy._dailyResetTime = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "adsDays": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new LoginRewardData(this);
              copy._adsDays = [];        for (let i of value) {
                copy._adsDays.push(JsonToInt32.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new LoginRewardData(this);
              copy._adsDays = copy._adsDays.concat([JsonToInt32.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._adsDays.length === 0) {
                return this;
              }
              const copy = new LoginRewardData(this);
              copy._adsDays = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._adsDays.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new LoginRewardData(this);
              copy._adsDays = copy._adsDays.slice();
              copy._adsDays[path[1]] = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new LoginRewardData(this);
              copy._adsDays = copy._adsDays.slice(0, path[1]).concat(copy._adsDays.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._adsDays.length) {
            return this;
          }
          const oldValue = this._adsDays[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new LoginRewardData(this);
          copy._adsDays = copy._adsDays.slice();
          copy._adsDays[key] = newValue;
          return copy;
        }
      }
      case "rewards7Days": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new LoginRewardData(this);
              copy._hasRewards7Days = true;
              copy._rewards7Days = LoginRewardData_RewardData7Days.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRewards7Days) {
                return this;
              }
              const copy = new LoginRewardData(this);
              copy._hasRewards7Days = false;
              copy._rewards7Days = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasRewards7Days) {
            const copy = new LoginRewardData(this);
            copy._hasRewards7Days = true;
            copy._rewards7Days = LoginRewardData_RewardData7Days.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._rewards7Days.apply(type, path.slice(1), value);
          if (newValue === this._rewards7Days) {
            return this;
          }
          const copy = new LoginRewardData(this);
          copy._rewards7Days = copy._rewards7Days.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {LoginRewardData} other
   * @returns {LoginRewardData}
   */
  merge(other) {
    const copy = new LoginRewardData(this);
    copy._rewardItems = this._rewardItems.concat(other._rewardItems);
    if (other._hasDailyResetTime) {
      copy._hasDailyResetTime = true;
      copy._dailyResetTime = other._dailyResetTime;
    }
    copy._adsDays = this._adsDays.concat(other._adsDays);
    if (other._hasRewards7Days) {
      if (copy._hasRewards7Days) {
        copy._rewards7Days = copy.rewards7Days.merge(other.rewards7Days);
      } else {
        copy._rewards7Days = other._rewards7Days;
      }
      copy._hasRewards7Days = true;
    }
    return copy;
  }
}
LoginRewardData.default = new LoginRewardData();
LoginRewardData.RewardData7Days = LoginRewardData_RewardData7Days;
class LoginRewardData_Builder {
  constructor(value) {
    this._value = new LoginRewardData(value);
  }
  build() {
    return new LoginRewardData(this._value);
  }
  addAllRewardItems(values) {
    this._value._rewardItems = this._value._rewardItems.concat(values);
    return this;
  }
  addRewardItems(value) {
    this._value._rewardItems = this._value._rewardItems.concat([value]);
    return this;
  }
  setRewardItems(index, value) {
    this._value._rewardItems = this._value._rewardItems.concat();
    this._value._rewardItems[index] = value;
    return this;
  }
  clearRewardItems() {
    this._value._rewardItems = [];
    return this;
  }
  setDailyResetTime(value) {
    this._value._hasDailyResetTime = true;
    this._value._dailyResetTime = value;
    return this;
  }
  deleteDailyResetTime() {
    this._value._hasDailyResetTime = false;
    this._value._dailyResetTime = null;
    return this;
  }
  addAllAdsDays(values) {
    this._value._adsDays = this._value._adsDays.concat(values);
    return this;
  }
  addAdsDays(value) {
    this._value._adsDays = this._value._adsDays.concat([value]);
    return this;
  }
  setAdsDays(index, value) {
    this._value._adsDays = this._value._adsDays.concat();
    this._value._adsDays[index] = value;
    return this;
  }
  clearAdsDays() {
    this._value._adsDays = [];
    return this;
  }
  setRewards7Days(value) {
    this._value._hasRewards7Days = true;
    this._value._rewards7Days = value;
    return this;
  }
  deleteRewards7Days() {
    this._value._hasRewards7Days = false;
    this._value._rewards7Days = null;
    return this;
  }
}
LoginRewardData.Builder = LoginRewardData_Builder;
class LoginRewardData_WithParent {
  /**
   * @param {LoginRewardData} value
   * @param {LoginRewardData_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return LoginRewardData.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfRewardItems() {
    if (!this._selfRewardItems) {
      this._selfRewardItems = [];
      for (let i of this._value.rewardItems) {
        this._selfRewardItems.push(new dcei_wildsky_common_proto.InventoryItemKeyValuePair.WithParent(i, null));
      }
    }
    return this._selfRewardItems;
  }
  get inherentRewardItems() {
    if (!this._inherentRewardItems) {
      this._inherentRewardItems = this._parent ? this._parent.rewardItems : [];
    }
    return this._inherentRewardItems;
  }
  get rewardItems() {
    if (!this._allRewardItems) {
      this._allRewardItems = this._parent ? this._parent.rewardItems.concat(this.selfRewardItems) : this.selfRewardItems;
    }
    return this._allRewardItems;
  }
  get hasDailyResetTime() {
    if (this._cachedHasDailyResetTime === undefined) {
      if (this._value.hasDailyResetTime) {
        this._cachedHasDailyResetTime = true;
      } else {
        this._cachedHasDailyResetTime = this._parent ? this._parent.hasDailyResetTime : false;
      }
    }
    return this._cachedHasDailyResetTime;
  }
  get dailyResetTime() {
    if (this._cachedDailyResetTime === undefined) {
      if (this._value.hasDailyResetTime) {
        this._cachedDailyResetTime = this._value.dailyResetTime;
      } else {
        this._cachedDailyResetTime = this._parent ? this._parent.dailyResetTime : this._value.dailyResetTime;
      }
    }
    return this._cachedDailyResetTime;
  }
  get selfAdsDays() {
    return this._value.adsDays;
  }
  get inherentAdsDays() {
    if (!this._inherentAdsDays) {
      this._inherentAdsDays = this._parent ? this._parent.adsDays : [];
    }
    return this._inherentAdsDays;
  }
  get adsDays() {
    if (!this._allAdsDays) {
      this._allAdsDays = this._parent ? this._parent.adsDays.concat(this.selfAdsDays) : this.selfAdsDays;
    }
    return this._allAdsDays;
  }
  get hasRewards7Days() {
    if (this._cachedHasRewards7Days === undefined) {
      if (this._value.hasRewards7Days) {
        this._cachedHasRewards7Days = true;
      } else {
        this._cachedHasRewards7Days = this._parent ? this._parent.hasRewards7Days : false;
      }
    }
    return this._cachedHasRewards7Days;
  }
  get rewards7Days() {
    if (!this._cachedRewards7Days) {
      if (this._value.hasRewards7Days) {
        this._cachedRewards7Days = new LoginRewardData_RewardData7Days.WithParent(this._value.rewards7Days, this._parent && this._parent.hasRewards7Days ? this._parent.rewards7Days : null);
      } else {
        this._cachedRewards7Days = this._parent ? new LoginRewardData_RewardData7Days.WithParent(LoginRewardData_RewardData7Days.default, this._parent.rewards7Days) : LoginRewardData_RewardData7Days.WithParent.default;
      }
    }
    return this._cachedRewards7Days;
  }
  update(current, parent) {
    const result = new LoginRewardData_WithParent(current, parent);
    if (this._selfRewardItems) {
      if (this._value.rewardItems === current.rewardItems) {
        result._selfRewardItems = this._selfRewardItems;
      } else {
        result._selfRewardItems = [];
        for (let i = 0; i < current.rewardItems.length; i++) {
          const oldValue = this._value.rewardItems[i];
          if (oldValue) {
            const oldCache = this._selfRewardItems[i];
            if (oldValue === current.rewardItems[i]) {
              result._selfRewardItems[i] = oldCache;
            } else {
              result._selfRewardItems[i] = oldCache.update(current.rewardItems[i], null);
            }
          } else {
            result._selfRewardItems[i] = new dcei_wildsky_common_proto.InventoryItemKeyValuePair.WithParent(current.rewardItems[i], null);
          }
        }
      }
    }
    if (this._cachedRewards7Days && this._value.hasRewards7Days && current.hasRewards7Days) {
      if (this._value.rewards7Days === current.rewards7Days && this._parent === parent) {
        result._cachedRewards7Days = this._cachedRewards7Days;
      } else {
        result._cachedRewards7Days = this._cachedRewards7Days.update(current.rewards7Days, parent && parent.hasRewards7Days ? parent.rewards7Days : null);
      }
    }
    return result;
  }
}
LoginRewardData_WithParent.default = new LoginRewardData_WithParent(LoginRewardData.default, null);
LoginRewardData.WithParent = LoginRewardData_WithParent;
class LoginRewardData_Descriptor {
  get rewardItems() {
    if (!this._rewardItems) {
      this._rewardItems = {
        name: "rewardItems",
        Name: "RewardItems",
        number: 1,
        protoType: 11,
        protoName: "reward_items",
        type: dcei_wildsky_common_proto.InventoryItemKeyValuePair,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._rewardItems;
  }
  get dailyResetTime() {
    if (!this._dailyResetTime) {
      this._dailyResetTime = {
        name: "dailyResetTime",
        Name: "DailyResetTime",
        number: 3,
        protoType: 5,
        protoName: "daily_reset_time",
        type: JsonToInt32,
        options: {
          comments: "Time in seconds passed from midnight",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._dailyResetTime;
  }
  get adsDays() {
    if (!this._adsDays) {
      this._adsDays = {
        name: "adsDays",
        Name: "AdsDays",
        number: 4,
        protoType: 5,
        protoName: "ads_days",
        type: JsonToInt32,
        isRepeated: true,
        options: {
          comments: "Index starts from 1 The days that reward can be doubled by watching ads",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._adsDays;
  }
  get rewards7Days() {
    if (!this._rewards7Days) {
      this._rewards7Days = {
        name: "rewards7Days",
        Name: "Rewards7Days",
        number: 5,
        protoType: 11,
        protoName: "rewards_7_days",
        type: LoginRewardData_RewardData7Days,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._rewards7Days;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.rewardItems,
        this.dailyResetTime,
        this.adsDays,
        this.rewards7Days,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForDailyResetTime",
        Name: "DummyOneofForDailyResetTime",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForRewards7Days",
        Name: "DummyOneofForRewards7Days",
        fields: [
          this.fields[3],
        ],
      });
    }
    return this._oneofs;
  }
}
LoginRewardData.descriptor = new LoginRewardData_Descriptor();
